import { Injectable } from '@angular/core';
import { LoggerFactory, Logger } from '../../core/logger.service';
import { TriggerbeeApi } from '../../core/triggerbee/triggerbee-requester.service';
import { TriggerbeeRequesterMock } from '../../core/triggerbee/triggerbee-requester.mock';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DemoAccountsService {
  private readonly logger: Logger;

  public readonly demoAccountSiteIdMax = 100;

  constructor(
    loggerFactory: LoggerFactory,
    private readonly requesterMock: TriggerbeeRequesterMock,
    private readonly http: HttpClient,
  ) {
    this.logger = loggerFactory.get('DemoAccountsService');
  }

  public async getMockDataForDemoAccounts(api: TriggerbeeApi, path: string): Promise<any> {
    const apiUrl = `/mocks/${TriggerbeeApi[api].toLowerCase()}.json`;
    const response = await this.http.get<string>(apiUrl).toPromise();
    const parsedData = await this.requesterMock.parseAsync(response, path, api);
    return parsedData.data;
  }
}
